import { CanAccess, useTranslate } from "ra-core";
import type { CSSProperties } from "react";

import "@/styles/mobile-more.css";

import { SettingsGroup, SettingsRow } from "../settings/MobileSettingsList";
import { MobileContent } from "./MobileContent";
import MobileHeader from "./MobileHeader";
import {
  MOBILE_MORE_GROUPS,
  MOBILE_MORE_PATH,
  type MobileModuleEntry,
} from "./mobileModules";

const MoreRow = ({ entry }: { entry: MobileModuleEntry }) => {
  const translate = useTranslate();
  const { icon: Icon } = entry;
  const row = (
    <SettingsRow
      to={entry.to}
      icon={<Icon className="size-[1.0625rem]" strokeWidth={2.1} />}
      label={translate(entry.label, { smart_count: 2 })}
      chevron
      className="mobile-more-row min-h-11 py-1.5 text-[16px]"
    />
  );

  return entry.access ? (
    <CanAccess resource={entry.access.resource} action={entry.access.action}>
      {row}
    </CanAccess>
  ) : (
    row
  );
};

/**
 * Phone "Más" screen: iOS inset grouped lists (icon chip, label, chevron)
 * with every module that has no tab in the bottom bar, gated like the
 * desktop entries. Compact 44px rows so the whole hub fits about one screen.
 */
export const MobileMorePage = () => {
  const translate = useTranslate();

  return (
    <>
      <MobileHeader>
        <h1 className="text-2xl font-semibold tracking-tight">
          {translate("crm.mobile.more.title")}
        </h1>
      </MobileHeader>
      <MobileContent>
        <nav
          aria-label={translate("crm.mobile.more.label")}
          className="flex flex-col gap-5 pt-1 pb-4"
        >
          {MOBILE_MORE_GROUPS.map((group, index) => (
            <div
              key={group.id}
              className="mobile-more-group"
              style={{ "--group-index": index } as CSSProperties}
            >
              <SettingsGroup title={translate(group.title)}>
                {group.entries.map((entry) => (
                  <MoreRow key={entry.to} entry={entry} />
                ))}
              </SettingsGroup>
            </div>
          ))}
        </nav>
      </MobileContent>
    </>
  );
};

MobileMorePage.path = MOBILE_MORE_PATH;
